export default [
    // packages ordered by priority
    "PFPF",
    "PFF",
    "HF",
    "PFPCS",
    "PFCS",
    "PFTT",
    "PFTTNL",
    "PFPTTF",
    "PFPTTNL",
    "PFTTF",
    "HTT",
    "HTTF",
    "HS",
    "PF",
    "PFP",

];
